<template>
  <Box>
    <v-layout
      :style="{ 'min-height': `${minHeight}px` }"
      fill-height
      align-center
      justify-center
    >
      <v-progress-circular color="primary" indeterminate />
    </v-layout>
  </Box>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    minHeight: {
      type: Number,
      default: 384
    }
  }
}
</script>
